<template>
	<div class="rebag">
		<HeaDer></HeaDer>
		<div class="bgcontent">
			<div class="box-card">
				<p class="yuetitle">恭喜您，找回报名序号成功！</p>
				<div class="mingxi">
					<p>
						报名序号为：<span><strong>{{signUpNo.signUpNo}}</strong></span>
					</p>
				</div>
				
				<div class="cardbut">
					<button class="yuefu"  @click="Register">去登录</button>
				</div>
			</div>
		</div>
		<FooTer></FooTer>
	</div>
</template>

<script scoped>
	import HeaDer from '../components/common/header.vue'
	import FooTer from '../components/common/footer.vue'
	export default {
		name:"sucxuhao",
		components:{
			HeaDer,
			FooTer
		},
		data() {
			return {
        signUpNo:''
			}
		},
		created() {
        if(this.$route.query){
        this.signUpNo=this.$route.query
      }

		},
		methods: {
			Register() {
				this.$router.push({
					path: '/'
				})
			
			}

		}

	}
	
</script>

<style  scoped>
	.rebag {
		background: url('../assets/denglu.png') center center no-repeat;
		width: 100%;
		height: 100%;
		position: fixed;
	}

	header {
		height: 120px;
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		margin-top: -20px;
	}

	.bap {
		color: #ffffff;
		float: left;
		line-height: 130px;
		letter-spacing: 2px;
		text-shadow: #333333 0px 0px 5px;
		font-size: 26px;
	}

	.bacontent {
		width: 1200px;
		margin: 0 auto;
		
	}

	.baimg {
		float: right;
		margin-top: 50px;
	}

	.bgcontent {
		margin-top: 40px;
	}

	.box-card {
		margin: 0 auto;
		width: 100%;
		margin: 0 auto;
		min-height: 620px;
	}

	.yuetitle {
		font-size: 20px;
		color: #000000;
		font-weight: bold;
		margin-top:80px;
	}

	.mingxi {
		padding: 0 50px;
	}

	.mingxi p {
		text-align: left;
		font-size:15px;
		line-height:34px;
		text-align: center;
		font-weight: bold;
		color: #DF0000;
	}
	.cardbut button {
		width: 100px;
		line-height: 28px;
		border-radius: 20px;
		margin-top: 20px;
		margin-bottom: 20px;
		outline: none;
	}

	.yuefu {
		border: 1px solid #0099ff;
		color: #fff;
		background-color: #0099ff;
	}

</style>
